import React from "react";
import Typography from "@common/components/Typography";
import { FormLabel, TextField, styled } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import HyperlinkParser from "../HyperlinkParser";

const StyledField = styled(TextField)(({ theme }) => ({
  borderTopLeftRadius: theme.radius.medium,
  borderTopRightRadius: theme.radius.medium,
  backgroundColor: theme.palette.background.paper,
  marginBottom: theme.spacing(1),
  "& > .MuiInput-root": {
    padding: theme.spacing(1, 2),
  },
  "& > label": {
    marginLeft: theme.spacing(1),
  },
}));

const StyledTypo = styled(Typography)({
  wordWrap: "break-word",
  wordBreak: "break-all",

  "& table": {
    float: "inherit",
  },
});

export type CommentTextSectionProps = {
  isEdit: boolean;
  content: string;
  label: string;
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  "data-testid"?: string;
};

const CommentTextSection = ({
  isEdit,
  content,
  label,
  name,
  onChange,
  "data-testid": testId,
}: CommentTextSectionProps) =>
  isEdit ? (
    <StyledField
      label={label}
      name={name}
      value={content}
      multiline
      rows={7}
      variant="standard"
      fullWidth
      disabled={!isEdit}
      onChange={onChange}
      data-testid={testId}
    />
  ) : (
    <FormControl
      fullWidth
      size="small"
      sx={{ minHeight: "200px", px: 2, overflowX: "scroll" }}
    >
      <FormLabel
        sx={{
          fontStyle: "italic",
        }}
      >
        {label}
      </FormLabel>
      {content?.split("\n").map((text, index) => (
        <StyledTypo key={index} component="div">
          {text !== "" ? (
            <HyperlinkParser content={text} html={true} testId={testId} />
          ) : (
            <br />
          )}
        </StyledTypo>
      ))}
    </FormControl>
  );

export default CommentTextSection;
